import React from "react";
import Icon from "@mdi/react";
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";

export const LeftArrow = ({ text, ...props }) => (
  <div className={`slideshow_arrow -left ${!!text ? "-text" : ""}`} {...props}>
    {text || <Icon path={mdiChevronLeft} color="white" size="48px" />}
  </div>
);

export const RightArrow = ({ text, ...props }) => (
  <div className={`slideshow_arrow -right ${!!text ? "-text" : ""}`} {...props}>
    {text || <Icon path={mdiChevronRight} color="white" size="48px" />}
  </div>
);
